const LABELS = {
  en: {
    historicalTrend: "Historical trend",
    historicalTrendHelp: "Historical trend — not a forecast or investment recommendation",
  },
  nl: {
    historicalTrend: "Historische trend",
    historicalTrendHelp: "Historische trend — geen voorspelling of beleggingsadvies",
  },
  de: {
    historicalTrend: "Historischer Trend",
    historicalTrendHelp: "Historischer Trend — keine Prognose oder Anlageempfehlung",
  },
  ar: {
    historicalTrend: "الاتجاه التاريخي",
    historicalTrendHelp: "الاتجاه التاريخي — ليس توقعًا ولا توصية استثمارية",
  },
  fr: {
    historicalTrend: "Tendance historique",
    historicalTrendHelp: "Tendance historique — ce n’est ni une prévision ni une recommandation d’investissement",
  },
  es: {
    historicalTrend: "Tendencia histórica",
    historicalTrendHelp: "Tendencia histórica — no es una previsión ni una recomendación de inversión",
  },
};

export function moodUiFor(language = "en") {
  const code = String(language || "en").toLowerCase().split("-")[0];
  return LABELS[code] || LABELS.en;
}
